import * as React      from 'react';
import * as ReactDOM   from 'react-dom';

import icons           from '../icons';
// import MenuItem        from '../components/MenuItem';
// import logout          from '../services/logout';

import * as PropTypes  from 'prop-types';

interface DropdownMenuState {
    isMenuOpen: boolean,
}

interface DropdownMenuProps {
    className: string,
    align: string,
    closeOnOutsideClick: boolean,
    toggleLabel: string,
    name?: string,
}

class DropdownMenu extends React.Component<DropdownMenuProps, DropdownMenuState> {
    static contextTypes = {
        setSession: PropTypes.func.isRequired,
        translate: PropTypes.func.isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false
        };
    }

    /* tslint:disable */
    _isMounted: boolean;
    /* tslint:enable */

    componentDidUpdate(prevState) {
        if (!this.state.isMenuOpen) {
            return;
        }

        if (this.state.isMenuOpen) {
            document.addEventListener('click', this.handleClickOutside);
        }
    }
    componentDidMount() {
        // This ensures that we don't mistakenly call handleClickOutside before we can remove the event listener on unmount.
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside = (e) => {
        if (!this.props.closeOnOutsideClick || !this._isMounted) {
            return;
        }

        const node = ReactDOM.findDOMNode(this);
        let target = e.target;

        while (target.parentNode) {
            if (target === node) {
                return;
            }

            target = target.parentNode;
        }

        this.close(e);
    }

    toggle = () => {
        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    }

    close = (e?: Event) => {
        this.setState({ isMenuOpen: false });
    }

    render() {
        const {align, className} = this.props;
        const listClassName = 'dd-items-' + (align);

        return (
            <div className={className}>
                <a className={name + '__toggle'} onClick={() => this.toggle()}>
                   {icons.meatball}
                </a>
                {this.state.isMenuOpen && <ul key="items" className={listClassName}>
                    {this.props.children}
                    <div className="settingsMenu__separator"/>
                    {/* <MenuItem
                        onClickAction={() => logout(this.context.setSession)}
                        label={this.context.translate('logout')}
                    /> */}
                </ul>
                }
            </div>
        );
    }
}

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu.tsx